import { render, staticRenderFns } from "./nullPage.vue?vue&type=template&id=4afd367e&scoped=true&"
import script from "./nullPage.vue?vue&type=script&lang=js&"
export * from "./nullPage.vue?vue&type=script&lang=js&"
import style0 from "./nullPage.vue?vue&type=style&index=0&id=4afd367e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd367e",
  null
  
)

export default component.exports